import React, {Component} from 'react';
import {withAdminAccountContext} from "../../../contexts/AdminAccountContext";
import {NavLink, withRouter} from "react-router-dom"
import {Formik} from "formik";
import {Col, Form, Row} from "react-bootstrap";
import {withAlert} from "react-alert";
import {ROUTE_ADMIN_USER_ACCOUNT_OVERVIEW, ROUTE_ADMIN_USERS_LIST} from "../../../routers/routes";
import styles from "./Search.module.css";
import PanelContainer from "../PanelContainer";
import * as Yup from "yup";
import AdminService from "../../../services/admin.service";
import LoadingData from "../../../components/common/LoadingData";
import TableRow from "../../../components/ui/AccountTable/TableRow";
import TableColHeader from "../../../components/ui/AccountTable/TableColHeader";
import TableCol from "../../../components/ui/AccountTable/TableCol";
import {accountCodeParse, numberWithCommas} from "../../../helpers/helpers";
import moment from "moment";
import ActionButton from "../../../components/ui/ActionButton";
import TableMobileRow from "../../../components/ui/AccountTable/TableMobileRow";
import TableMobileCol from "../../../components/ui/AccountTable/TableMobileCol";
import TableColValue from "../../../components/ui/AccountTable/TableColValue";
import AccountTable from "../../../components/ui/AccountTable/AccountTable";
import PageTitleContainer from "../Search/PageTitleContainer";
class Search extends Component {
    refForm = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            search: true,
            params: null,
            error: false,
            searched: false,
            searching: false,
            searchFields: {
                account_code: "",
                email: ""
            },
            infoWrapperWidth: null
        }
    }
    componentDidMount() {
        if(localStorage.getItem('backed_from_account_state')){
            let state = JSON.parse(localStorage.getItem('backed_from_account_state'));
            localStorage.removeItem('backed_from_account_state');
            this.setState(state)
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.refForm.current && this.state.infoWrapperWidth !== this.refForm.current.clientWidth){
            this.setState({
                infoWrapperWidth: this.refForm.current.clientWidth
            })
        }

    }

    handleSubmit = async (values, actions) => {
        const {history} = this.props;
        this.setState({ error: false, searching:true })
        if(values.account_code || values.email){
            this.setState({
                searchFields: {
                    account_code: values.account_code.replaceAll(" ", ""),
                    email: values.email
                },
                searching: false,
                searched: true
            })
        }else{
            this.setState({ error: true, searching: false })
        }
    }
    onClickRow = (e, row) => {
        const {accountContext} = this.props;
        e.preventDefault();
        accountContext.doGotoProfile(ROUTE_ADMIN_USER_ACCOUNT_OVERVIEW, ":profileId", row['account_code'], this.state, this.refTable.getState())
    }
    render() {
        const {accountContext} = this.props;
        return (
            <PanelContainer>
                <div className={"form-center"}>
                    <Formik
                        enableReinitialize={true}
                        initialValues={this.state.searchFields}
                        validationSchema={Yup.object().shape({

                        })}
                        onSubmit={this.handleSubmit}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleSubmit,
                              isSubmitting,
                              setFieldValue
                          }) => (
                            <Form onSubmit={handleSubmit} className={styles.FullWidth} style={{width: "40%"}} ref={this.refForm}>
                                <Form.Group as={Row} className={"mb-3"}>
                                    <Col className={"start-center-value"}>
                                        <Form.Label className={styles.FormLabel}></Form.Label>
                                        <PageTitleContainer center={true} full={true}/>
                                    </Col>
                                </Form.Group>
                                <Form.Group className={"mb-3"}>
                                    <Col className={"start-center-value"}>
                                        <Form.Label className={styles.FormLabel}>ACCOUNT ID :</Form.Label>
                                        <Form.Control type="text"
                                                      name={"account_code"}
                                                      onChange={handleChange}
                                                      value={values.account_code}
                                                      disabled={this.state.searching}
                                                      isValid={touched.account_code && !errors.account_code}
                                                      isInvalid={touched.account_code && errors.account_code}
                                                      autoComplete="off"
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group className={"mb-3"}>
                                    <Col className={"start-center-value"}>
                                        <Form.Label className={styles.FormLabel}>E-MAIL :</Form.Label>
                                        <Form.Control type="text"
                                                      name={"email"}
                                                      onChange={handleChange}
                                                      value={values.email}
                                                      isValid={touched.email && !errors.email}
                                                      isInvalid={touched.email && errors.email}
                                                      disabled={this.state.searching}
                                                      autoComplete="off"
                                        />
                                    </Col>
                                </Form.Group>

                                <Form.Group className={"d-flex justify-content-center"}>
                                    <Form.Label className={styles.FormLabel}></Form.Label>
                                    <button className={"btn btn-account full-width"} disabled={this.state.searching} type={"submit"}>Search</button>
                                </Form.Group>

                                {this.state.error && <Form.Group as={Row} className={"text-center mt-3"}>
                                    <Col className={"text-center mb-3"}>
                                        <Form.Text className="text-danger mt-2">
                                            You need enter at latest one search criteria for search to be effective.
                                        </Form.Text>
                                    </Col>
                                </Form.Group>}




                            </Form>
                        )}
                    </Formik>

                </div>
                <div className={"form-center"}>
                    {this.state.searched &&
                    <AccountTable  full={true} loadData={AdminService.getUsersList} sort={"id"} align={"asc"}
                                   header={(onSort, sort, align) => {
                                       return <TableRow>
                                           <TableColHeader sort={"id"}>#</TableColHeader>
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableColHeader sort={"first_name"} >FIRST NAME</TableColHeader>}
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableColHeader sort={"last_name"}  >LAST NAME</TableColHeader>}
                                           {process.env.REACT_APP_NAME !== "swissco.gaming" && <TableColHeader sort={"email"} >EMAIL</TableColHeader>}
                                           <TableColHeader>ID NUMBER</TableColHeader>
                                           <TableColHeader>MEMBER SINCE</TableColHeader>
                                           <TableColHeader>ACCOUNT BALANCE</TableColHeader>
                                       </TableRow>
                                   }}
                                   render={(row, index, number) =>
                                       <TableRow key={index} onClick={(e) => this.onClickRow(e, row)} >
                                           <TableCol>{number}</TableCol>
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableCol>{row['first_name']}</TableCol>}
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableCol>{row['last_name']}</TableCol>}
                                           {process.env.REACT_APP_NAME !== "swissco.gaming" && <TableCol>{row['email']}</TableCol>}
                                           <TableCol><span>{accountCodeParse(row['account_code'])}</span></TableCol>
                                           <TableCol>{moment(new Date(row['created_at'])).format('ddd, MMMM DD, YYYY')}</TableCol>
                                           <TableCol><span className={"yellow-text"}>{numberWithCommas(row['balance'], true)}</span></TableCol>
                                       </TableRow>
                                   }
                                   mobile={(row, index, number, total, onNext, onPrevious) =>
                                       <TableMobileRow key={index}>
                                           <TableMobileCol>
                                               <label>Number</label>
                                               <TableColValue pagination={true} onNext={onNext} onPrevious={onPrevious}>{number} / {total}</TableColValue>
                                           </TableMobileCol>
                                           <TableMobileCol>
                                               <label>ID NUMBER</label>
                                               <TableColValue><span>{accountCodeParse(row['account_code'])}</span></TableColValue>
                                           </TableMobileCol>
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableMobileCol>
                                               <label>FIRST NAME</label>
                                               <TableColValue>{row['first_name']}</TableColValue>
                                           </TableMobileCol>}
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableMobileCol>
                                               <label>LAST NAME</label>
                                               <TableColValue>{row['last_name']}</TableColValue>
                                           </TableMobileCol>}
                                           {process.env.REACT_APP_NAME === "swissco.gaming" && <TableMobileCol>
                                               <label>E-MAIL ADDRESS</label>
                                               <TableColValue>{row['email']}</TableColValue>
                                           </TableMobileCol>}
                                           <TableMobileCol>
                                               <label>MEMBER SINCE</label>
                                               <TableColValue>{moment(new Date(row['created_at'])).format('ddd, MMMM DD, YYYY')}</TableColValue>
                                           </TableMobileCol>
                                           <TableMobileCol>
                                               <label>ACCOUNT BALANCE</label>
                                               <TableColValue><span className={"yellow-text"}>{numberWithCommas(row['balance'], true)}</span></TableColValue>
                                           </TableMobileCol>
                                           <TableMobileCol>
                                               <TableColValue>
                                                   <button onClick={(e) => this.onClickRow(e, row)}>View user profile ...</button>
                                               </TableColValue>
                                           </TableMobileCol>
                                       </TableMobileRow>}
                                   search={this.state.searchFields}
                                   ref={(ref) => this.refTable = ref}
                    />}
                </div>
            </PanelContainer>

        )
    }
}

export default withAlert()(withRouter(withAdminAccountContext(Search)));